/* eslint-disable react-hooks/rules-of-hooks */
import { useParams } from 'react-router-dom';
import useAppState from '../state/appState';
import { Field } from '../types/fields';
import { RouteableFC } from '../types/react';
import { ShowElement } from './values/Get';
import { PageConf, FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';
import { pageHasSummaryElement } from '../helpers/pageHasSummaryElement';
import { NarrowGridItem, WideGridItem } from './layout/grids';
import { SubText } from './SubText';

interface Props {
    pageConf: PageConf;
}

type ContentsProps = {
    formConfig: FormConfig | undefined;
    pageConf: PageConf;
};

const Contents = ({ formConfig, pageConf }: ContentsProps) => {
    const { caption, subText, elements, hasWideContent: isWidePage } = pageConf;
    const isOnSummaryPage = pageHasSummaryElement(formConfig, pageConf.pageId);
    const GridItemVariant = isWidePage ? WideGridItem : NarrowGridItem;

    return (
        <GridItemVariant>
            {!isOnSummaryPage && (
                <div className="u-spacing-stack-m">
                    <h4 className="page-header">{caption}</h4>
                    {subText && (
                        <>
                            <SubText SubTextList={subText} />
                        </>
                    )}
                </div>
            )}
            <div className="u-spacing-stack-xl">
                {elements.map((element: Field, index: number) => (
                    <div className="u-spacing-stack-m" key={`element-${index}`}>
                        <ShowElement {...element} key={element.elementId} />
                    </div>
                ))}
            </div>
        </GridItemVariant>
    );
};

const Page: RouteableFC<Props> = ({ pageConf }) => {
    const formConfig = useAppState((state) => state.formConfig);

    // Extracted to own component as this page is really large
    // The component can then be further sub composed if necessary
    return <Contents formConfig={formConfig} pageConf={pageConf} />;
};

// See Form for almost identical code
Page.InitFromRoute = () => {
    const { pageId } = useParams();

    const formConfig = useAppState((state) => state.formConfig);

    if (!formConfig) {
        throw new Error('Page.InitFromRoute: No state.formConfig');
    }

    const pageConf = formConfig.pages.find((page) => page.pageId === pageId);

    // return <Navigate to={`../${formConfig.pages[0].pageId}`} />;
    if (!pageConf) {
        throw new Error('Page.InitFromRoute: No pageConf from pageId: ' + pageId);
    }

    return <Page pageConf={pageConf} />;
};

export default Page;
